import type { ReactNode } from "react";
import { FaceoffDot, type FaceoffTone } from "../rink/FaceoffDot";

export type StatusTone = "live" | "linked" | "idle";

const DOT: Record<StatusTone, FaceoffTone> = {
  live: "red",
  linked: "blue",
  idle: "hollow",
};

/** Status label with a faceoff dot: live/locked (red), linked/active (blue), idle (hollow). */
export function Status({ tone, children }: { tone: StatusTone; children: ReactNode }) {
  return (
    <span className="inline-flex items-center gap-2 text-note font-semibold text-ink-2">
      <FaceoffDot tone={DOT[tone]} />
      {children}
    </span>
  );
}
